import React, { FC } from "react";
import { Icon, IconProps } from "../../../icons/components/Icon";
import { useTheme } from "../../../styles/theme";

export const RequisitionStatusGenericIcon: FC<IconProps> = (props) => {
  const theme = useTheme();

  return (
    <Icon height="24px" {...props} viewBox="0 0 33 33">
      <circle
        opacity="0.1"
        cx="16.5"
        cy="16.5"
        r="16.5"
        fill={theme.colors.grey}
      />
      <path
        d="M18.5 6.5H10.5C9.4 6.5 8.51 7.4 8.51 8.5L8.5 24.5C8.5 25.6 9.39 26.5 10.49 26.5H22.5C23.6 26.5 24.5 25.6 24.5 24.5V12.5L18.5 6.5ZM17.5 13.5V8L23 13.5H17.5Z"
        fill={theme.colors.green}
      />
      <path
        d="M12.5 17.5H20.5V19.5H12.5V17.5Z"
        fill={theme.colors.white}
        opacity="0.85"
      />
      <path
        d="M12.5 21.5H20.5V23.5H12.5V21.5Z"
        fill={theme.colors.white}
        opacity="0.85"
      />
      <path
        d="M12.5 13.5H15.5V15.5H12.5V13.5Z"
        fill={theme.colors.white}
        opacity="0.85"
      />
    </Icon>
  );
};
